// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1cJ3g","image":"Item_image__1TIjT"};